import {
  ContainerProps,
  ControlProps,
  CSSObjectWithLabel,
  DropdownIndicatorProps,
  StylesConfig,
} from 'react-select';
import { Colors, Media } from 'enums';
import { OBJECT_FOR_SCROLL_WITH_PADDING } from 'styles/customScrollWithPadding';

const mediaNotebook = `@media ${Media.notebook}`;

export const SelectorDefaultStyles = (
  isError?: boolean,
  isDatePickerSelector?: boolean,
  isSelectorWithChips?: boolean,
  indicator?: string,
): StylesConfig => ({
  container: (base: CSSObjectWithLabel, { isDisabled }: ContainerProps) => ({
    ...base,
    width: '100%',
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    textAlign: 'left',
    boxShadow: 'none',
    opacity: isDisabled ? 0.5 : 1,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    userSelect: 'none',
    [mediaNotebook]: {
      fontSize: '16px',
    },
  }),
  control: (
    base: CSSObjectWithLabel,
    { menuIsOpen, isDisabled }: ControlProps,
  ) => ({
    ...base,
    display: 'flex',
    flexWrap: 'nowrap',
    height: isSelectorWithChips ? 'max-content' : '48px',
    minHeight: isSelectorWithChips ? '48px' : '',
    padding: '0 8px',
    backgroundColor: isDatePickerSelector ? Colors.gray4 : Colors.white,
    borderRadius: '10px',
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    border: menuIsOpen
      ? `1px solid ${Colors.yellow1}`
      : '1px solid transparent',
    borderColor: isError ? `${Colors.red1} !important` : '',
    boxShadow: 'none',

    [mediaNotebook]: {
      padding: '0 16px',
      height: isSelectorWithChips ? 'max-content' : '56px',
      minHeight: isSelectorWithChips ? '56px' : '',
      backgroundColor: menuIsOpen ? Colors.white : Colors.background,
    },

    '&:hover': {
      border: `1px solid ${menuIsOpen ? Colors.yellow1 : Colors.gray3}`,
    },
  }),
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    borderRadius: 10,
    border: 'none',
    boxShadow: '0px 4px 15px 4px rgba(0, 0, 0, 0.08);',
    zIndex: 20,
  }),
  menuList: (base: CSSObjectWithLabel) => ({
    ...base,
    className: 'scrolling-menu-list',
    borderRadius: 10,
    ...OBJECT_FOR_SCROLL_WITH_PADDING,
  }),
  singleValue: (base: CSSObjectWithLabel) => ({
    ...base,
    position: 'absolute',
    overflow: 'visible',
    whiteSpace: 'nowrap',
    maxWidth: 'none',
  }),
  valueContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    display: 'flex',
    padding: '0px 8px',
    alignItems: 'center',
    overflow: 'visible',
    input: {
      width: '100%',
    },
  }),
  option: (base: CSSObjectWithLabel) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: Colors.white,
    color: Colors.gray1,
    padding: '18px 24px',
    cursor: 'pointer',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    height: '48px',
    '&:active': {
      backgroundColor: 'transparent',
    },
    '&:hover': {
      backgroundColor: Colors.background,
    },
    [mediaNotebook]: {
      fontSize: '16px',
    },
  }),
  noOptionsMessage: (base: CSSObjectWithLabel) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    padding: '0px 16px',
    height: 64,
    textAlign: 'left',
    color: Colors.gray1,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 14,
  }),
  dropdownIndicator: (
    base: CSSObjectWithLabel,
    { selectProps }: DropdownIndicatorProps,
  ) => ({
    ...base,
    padding: '0px',
    transition: 'all .2s ease',
    transform:
      selectProps.menuIsOpen && indicator !== 'search' ? 'rotate(180deg)' : '',
  }),
  indicatorsContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    padding: '8px 30px 8px 8px',
  }),
  placeholder: (base: CSSObjectWithLabel) => ({
    ...base,
    color: Colors.gray2,
    position: 'absolute',
    overflow: 'visible',
    whiteSpace: 'nowrap',
    fontSize: '14px',

    [mediaNotebook]: {
      fontSize: '16px',
    },
  }),
});
